import {axios} from '@/utils/request';
import generalMixin from '@/mixins/general';

export function getBadges(data) {
  const filtersString = generalMixin.methods.objectToQuery(data);
  return axios({url: `v2/badges${filtersString}`, method: 'get'});
}

export function getBadge(reference) {
  return axios({url: `v2/badges/${reference}`, method: 'get'});
}

export function createBadge(data) {
  return axios({url: `v2/badges`, method: 'post', data: data});
}

export function updateBadge(reference, data) {
  return axios({url: `v2/badges/${reference}`, method: 'put', data: data});
}

export function revokeBadge(reference) {
  return axios({url: `v2/badges/${reference}/revoke`, method: 'patch'});
}

export function reactivateBadge(reference) {
  return axios({url: `v2/badges/${reference}/reactivate`, method: 'patch'});
}
